(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initFooterAccordions(root) {
      root.querySelectorAll('[data-footer-accordion]').forEach(function (menu) {
        var toggle = menu.querySelector('.v3-footer__toggle');
        if (!toggle || toggle.dataset.bound) return;
        toggle.dataset.bound = 'true';
        toggle.addEventListener('click', function () {
          var open = menu.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }

    initFooterAccordions(document);
    document.addEventListener('shopify:section:load', function (event) {
      initFooterAccordions(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  if (!customElements.get('cart-page')) {
    class CartPage extends HTMLElement {
      connectedCallback() {
        this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.section = this.closest('.main-cart');
        this.addEventListener('click', this.onClick.bind(this));
        this.addEventListener('change', this.onChange.bind(this));
      }

      onClick(event) {
        const button = event.target.closest('[data-cart-qty]');
        if (!button) return;

        const item = button.closest('[data-cart-item]');
        const input = item && item.querySelector('[data-cart-qty-input]');
        if (!input) return;

        event.preventDefault();
        const current = Number(input.value || 0);
        const next = button.dataset.cartQty === 'increase' ? current + 1 : Math.max(0, current - 1);
        input.value = String(next);
        this.updateQuantity(input.dataset.lineKey, next);
      }

      onChange(event) {
        const input = event.target.closest('[data-cart-qty-input]');
        if (!input) return;
        const quantity = Math.max(0, Number(input.value || 0));
        input.value = String(quantity);
        this.updateQuantity(input.dataset.lineKey, quantity);
      }

      async updateQuantity(key, quantity) {
        if (!key) return;
        if (this.section) this.section.classList.add('is-updating');

        try {
          const response = await fetch(this.root + 'cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
            },
            body: JSON.stringify({ id: key, quantity: quantity }),
          });

          if (!response.ok) throw new Error('Cart update failed');
          window.location.reload();
        } catch (error) {
          if (this.section) this.section.classList.remove('is-updating');
        }
      }
    }

    customElements.define('cart-page', CartPage);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-col-sort]').forEach(function (select) {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', function () {
        if (select.form) select.form.submit();
      });
    });

    var configEl = document.getElementById('CollectionAvailabilityConfig');
    var grid = document.querySelector('[data-product-grid]');
    var pagination = document.querySelector('[data-collection-pagination]');
    if (!configEl || !grid) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var perPage = config.perPage || 24;
    var sortedItems = null;
    var cacheKey = null;

    function getCurrentPage() {
      var params = new URLSearchParams(window.location.search);
      var page = parseInt(params.get('page'), 10);
      return page > 0 ? page : 1;
    }

    function buildCacheKey() {
      var params = new URLSearchParams(window.location.search);
      params.delete('page');
      params.delete('view');
      return 'col-avail:' + config.url + ':' + params.toString() + ':' + config.productsCount;
    }

    function buildDataUrl(pageNum) {
      var params = new URLSearchParams(window.location.search);
      params.delete('page');
      params.set('view', 'availability-data');
      params.set('page', String(pageNum));
      if (config.sortBy && !params.has('sort_by')) {
        params.set('sort_by', config.sortBy);
      }
      return config.url + '?' + params.toString();
    }

    function pageUrl(pageNum) {
      var params = new URLSearchParams(window.location.search);
      if (pageNum <= 1) {
        params.delete('page');
      } else {
        params.set('page', String(pageNum));
      }
      var qs = params.toString();
      return config.url + (qs ? '?' + qs : '');
    }

    function parseBatch(html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var list = doc.querySelector('#availability-data');
      if (!list) return { items: [], pages: 1 };
      var items = Array.prototype.slice.call(list.querySelectorAll('.col-grid__item'));
      var pages = parseInt(list.getAttribute('data-pages'), 10) || 1;
      return { items: items, pages: pages };
    }

    function fetchAllProducts() {
      cacheKey = buildCacheKey();

      try {
        var cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          var parsed = JSON.parse(cached);
          if (parsed && parsed.length) {
            return Promise.resolve(parsed.map(function (entry) {
              var wrap = document.createElement('div');
              wrap.innerHTML = entry.html;
              var el = wrap.firstElementChild;
              return el;
            }));
          }
        }
      } catch (e) {}

      return fetch(buildDataUrl(1), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('availability-data fetch failed');
          return res.text();
        })
        .then(function (html) {
          var first = parseBatch(html);
          if (!first.items.length && config.productsCount > 0) {
            throw new Error('availability-data returned no products');
          }
          var all = first.items.slice();
          var pages = first.pages;
          if (pages <= 1) return all;

          var requests = [];
          for (var p = 2; p <= pages; p++) {
            requests.push(
              fetch(buildDataUrl(p), { credentials: 'same-origin' }).then(function (res) {
                if (!res.ok) throw new Error('availability-data page fetch failed');
                return res.text();
              }).then(function (pageHtml) {
                return parseBatch(pageHtml).items;
              })
            );
          }

          return Promise.all(requests).then(function (batches) {
            batches.forEach(function (batch) {
              all = all.concat(batch);
            });
            return all;
          });
        })
        .then(function (items) {
          try {
            var payload = items.map(function (el) {
              return {
                available: el.getAttribute('data-product-available') === 'true',
                html: el.outerHTML
              };
            });
            sessionStorage.setItem(cacheKey, JSON.stringify(payload));
          } catch (e) {}
          return items;
        });
    }

    function sortByAvailability(items) {
      var available = [];
      var soldOut = [];
      items.forEach(function (item) {
        if (item.getAttribute('data-product-available') === 'true') {
          available.push(item);
        } else {
          soldOut.push(item);
        }
      });
      return available.concat(soldOut);
    }

    function renderPage(pageNum) {
      if (!sortedItems || !sortedItems.length) return;

      var totalPages = Math.max(1, Math.ceil(sortedItems.length / perPage));
      if (pageNum > totalPages) pageNum = totalPages;
      if (pageNum < 1) pageNum = 1;

      var start = (pageNum - 1) * perPage;
      var slice = sortedItems.slice(start, start + perPage);

      grid.innerHTML = '';
      slice.forEach(function (item) {
        grid.appendChild(item.cloneNode(true));
      });

      grid.classList.remove('is-sorting');
      grid.setAttribute('aria-busy', 'false');

      var productGrid = grid.closest('product-grid');
      if (productGrid && typeof productGrid._initQuickAdd === 'function') {
        productGrid._initQuickAdd();
      }

      renderPagination(pageNum, totalPages);
    }

    function renderPagination(currentPage, totalPages) {
      if (!pagination) return;
      var inner = pagination.querySelector('.col-pagination__inner');
      if (!inner) return;

      if (totalPages <= 1) {
        pagination.hidden = true;
        inner.innerHTML = '';
        return;
      }

      pagination.hidden = false;
      var html = '';

      if (currentPage > 1) {
        html += '<a href="' + pageUrl(currentPage - 1) + '" class="col-pagination__nav" data-avail-page="' + (currentPage - 1) + '">' + (config.prevLabel || 'Previous') + '</a>';
      }

      html += '<div class="col-pagination__pages">';
      var lastRendered = 0;
      for (var i = 1; i <= totalPages; i++) {
        var show =
          i === 1 ||
          i === totalPages ||
          Math.abs(i - currentPage) <= 2;

        if (!show) continue;

        if (i - lastRendered > 1) {
          html += '<span class="col-pagination__deco" aria-hidden="true">…</span>';
        }

        if (i === currentPage) {
          html += '<span class="col-pagination__page is-current" aria-current="page">' + i + '</span>';
        } else {
          html += '<a href="' + pageUrl(i) + '" class="col-pagination__page" data-avail-page="' + i + '">' + i + '</a>';
        }
        lastRendered = i;
      }
      html += '</div>';

      if (currentPage < totalPages) {
        html += '<a href="' + pageUrl(currentPage + 1) + '" class="col-pagination__nav" data-avail-page="' + (currentPage + 1) + '">' + (config.nextLabel || 'Next') + '</a>';
      }

      inner.innerHTML = html;

      inner.querySelectorAll('[data-avail-page]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var nextPage = parseInt(link.getAttribute('data-avail-page'), 10);
          var url = pageUrl(nextPage);
          window.history.pushState({ availPage: nextPage }, '', url);
          renderPage(nextPage);
          var wrapper = document.querySelector('[data-collection-wrapper]');
          if (wrapper) wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    function init() {
      fetchAllProducts()
        .then(function (items) {
          sortedItems = sortByAvailability(items);
          renderPage(getCurrentPage());
        })
        .catch(function () {
          grid.classList.remove('is-sorting');
          grid.setAttribute('aria-busy', 'false');
          if (pagination) {
            var fallback = pagination.querySelector('[data-pagination-fallback]');
            if (fallback && fallback.children.length) {
              pagination.hidden = false;
            }
          }
        });
    }

    window.addEventListener('popstate', function () {
      if (sortedItems) renderPage(getCurrentPage());
    });

    init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    function submitWithTransition(form) {
      if (!form) return;
      if (!document.startViewTransition) {
        form.submit();
        return;
      }
      document.startViewTransition(function () {
        form.submit();
      });
    }

    document.querySelectorAll('[data-search-sort]').forEach(function (select) {
      if (select.dataset.bound) return;
      select.dataset.bound = 'true';
      select.addEventListener('change', function () {
        submitWithTransition(select.form);
      });
    });

    document.querySelectorAll('[data-search-transition]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      form.addEventListener('submit', function (event) {
        if (!document.startViewTransition) return;
        event.preventDefault();
        submitWithTransition(form);
      });
    });

    var configEl = document.getElementById('SearchPagingConfig');
    var grid = document.querySelector('[data-search-grid]');
    var pagination = document.querySelector('[data-search-pagination]');
    var countEl = document.querySelector('[data-search-count]');
    if (!configEl || !grid || grid.dataset.bound) return;
    grid.dataset.bound = 'true';

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var perPage = config.perPage || 24;
    var MAX_PARALLEL = 4;
    var items = null;

    function getCurrentPage() {
      var page = parseInt(new URLSearchParams(window.location.search).get('page'), 10);
      return page > 0 ? page : 1;
    }

    function dataUrl(pageNum) {
      var params = new URLSearchParams(window.location.search);
      params.set('view', 'data');
      params.set('page', String(pageNum));
      return window.location.pathname + '?' + params.toString();
    }

    function pageUrl(pageNum) {
      var params = new URLSearchParams(window.location.search);
      if (pageNum <= 1) {
        params.delete('page');
      } else {
        params.set('page', String(pageNum));
      }
      return window.location.pathname + '?' + params.toString();
    }

    function fetchBatch(pageNum) {
      return fetch(dataUrl(pageNum), { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('search data fetch failed');
          return res.text();
        })
        .then(function (html) {
          var list = new DOMParser().parseFromString(html, 'text/html').querySelector('#search-data');
          if (!list) throw new Error('search data missing');
          return {
            items: Array.prototype.slice.call(list.querySelectorAll('.search-grid__item')),
            pages: parseInt(list.getAttribute('data-pages'), 10) || 1
          };
        });
    }

    function fetchAll() {
      return fetchBatch(1).then(function (first) {
        var batches = [first.items];
        var queue = [];
        for (var p = 2; p <= first.pages; p++) queue.push(p);

        function worker() {
          if (!queue.length) return Promise.resolve();
          var pageNum = queue.shift();
          return fetchBatch(pageNum).then(function (batch) {
            batches[pageNum - 1] = batch.items;
            return worker();
          });
        }

        var workers = [];
        for (var i = 0; i < MAX_PARALLEL; i++) workers.push(worker());
        return Promise.all(workers).then(function () {
          return batches.reduce(function (all, batch) {
            return all.concat(batch || []);
          }, []);
        });
      });
    }

    function renderPage(pageNum) {
      var totalPages = Math.max(1, Math.ceil(items.length / perPage));
      pageNum = Math.min(Math.max(pageNum, 1), totalPages);

      grid.innerHTML = '';
      items.slice((pageNum - 1) * perPage, pageNum * perPage).forEach(function (item) {
        grid.appendChild(item.cloneNode(true));
      });

      var productGrid = grid.closest('product-grid');
      if (productGrid && typeof productGrid._initQuickAdd === 'function') {
        productGrid._initQuickAdd();
      }

      if (countEl && countEl.dataset.countTemplate) {
        countEl.textContent = countEl.dataset.countTemplate.replace('__COUNT__', items.length);
      }

      renderPagination(pageNum, totalPages);
    }

    function renderPagination(currentPage, totalPages) {
      if (!pagination) return;
      var inner = pagination.querySelector('.search-pagination__inner');
      if (!inner) return;

      if (totalPages <= 1) {
        pagination.hidden = true;
        return;
      }
      pagination.hidden = false;

      var html = '';
      if (currentPage > 1) {
        html += '<a href="' + pageUrl(currentPage - 1) + '" class="search-pagination__nav" data-search-page="' + (currentPage - 1) + '">' + config.prevLabel + '</a>';
      }
      html += '<div class="search-pagination__pages">';
      var lastRendered = 0;
      for (var i = 1; i <= totalPages; i++) {
        if (i !== 1 && i !== totalPages && Math.abs(i - currentPage) > 2) continue;
        if (i - lastRendered > 1) {
          html += '<span class="search-pagination__deco" aria-hidden="true">…</span>';
        }
        if (i === currentPage) {
          html += '<span class="search-pagination__page is-current" aria-current="page">' + i + '</span>';
        } else {
          html += '<a href="' + pageUrl(i) + '" class="search-pagination__page" data-search-page="' + i + '">' + i + '</a>';
        }
        lastRendered = i;
      }
      html += '</div>';
      if (currentPage < totalPages) {
        html += '<a href="' + pageUrl(currentPage + 1) + '" class="search-pagination__nav" data-search-page="' + (currentPage + 1) + '">' + config.nextLabel + '</a>';
      }
      inner.innerHTML = html;

      inner.querySelectorAll('[data-search-page]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var nextPage = parseInt(link.getAttribute('data-search-page'), 10);
          window.history.pushState({ searchPage: nextPage }, '', pageUrl(nextPage));
          renderPage(nextPage);
          grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });
    }

    grid.setAttribute('aria-busy', 'true');
    fetchAll()
      .then(function (all) {
        items = all;
        grid.setAttribute('aria-busy', 'false');
        if (items.length) renderPage(getCurrentPage());
      })
      .catch(function () {
        grid.setAttribute('aria-busy', 'false');
      });

    window.addEventListener('popstate', function () {
      if (items && items.length) renderPage(getCurrentPage());
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-vendors"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var content = document.querySelector('[data-vb-content]');
    if (!content) return;

    var searchInput  = document.querySelector('[data-vb-search]');
    var emptyMsg     = document.querySelector('[data-vb-empty]');
    var totalDisplay = document.querySelector('[data-vb-total-label]');
    var groups       = Array.from(content.querySelectorAll('[data-vb-group]'));
    var alphaLinks   = Array.from(document.querySelectorAll('[data-alpha-letter]'));
    var countTemplate = searchInput && searchInput.dataset.vbCountTemplate
      ? searchInput.dataset.vbCountTemplate
      : '__COUNT__ brands';

    /* Smooth-scroll alphabet links */
    alphaLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById('vbl-' + link.dataset.alphaLetter);
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.scrollY - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    /* Highlight active letter on scroll */
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var letter = entry.target.dataset.vbGroup;
          alphaLinks.forEach(function (l) {
            l.classList.toggle('is-active', l.dataset.alphaLetter === letter);
          });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      groups.forEach(function (g) { observer.observe(g); });
    }

    /* Live search */
    if (!searchInput) return;
    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim().toLowerCase();
      var visible = 0;

      groups.forEach(function (grp) {
        var items = Array.from(grp.querySelectorAll('[data-brand-name]'));
        var grpVisible = 0;
        items.forEach(function (item) {
          var match = !q || (item.dataset.brandName || '').includes(q);
          item.hidden = !match;
          if (match) grpVisible++;
        });
        grp.hidden = grpVisible === 0;
        visible += grpVisible;
      });

      if (emptyMsg) emptyMsg.hidden = visible > 0;
      if (totalDisplay) totalDisplay.textContent = countTemplate.replace('__COUNT__', String(visible));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
